import React, { useState, useRef, useEffect } from "react";
import "./AIDemoV2.css";
import Message from "./MessageV1";
import Courses from "./Courses";
import useChat from "../auth/util/useChatV2";
import Header from "./Header";
import { useDispatch, useSelector } from "react-redux";
import { getUserSubInterestsAction } from "../actions/profileActions";
import { Alert, Box, Divider, Snackbar } from "@mui/material";
import {
  Chart as ChartJS,
  RadialLinearScale,
  PointElement,
  LineElement,
  Filler,
  Legend,
} from "chart.js";
import { Radar } from "react-chartjs-2";
import {
  ArrowLeft,
  ArrowUpwardOutlined,
  CloseOutlined,
  EditOutlined,
  ErrorOutline,
} from "@mui/icons-material";
import { Loading } from "react-admin";
import useGeneratorV2 from "../auth/util/useGeneratorV2";
import Loader2 from "./Loader2";
import CustomModal from "./utils/CustomModal/CustomModal";
import { reportAI } from "../../services/aiService";

ChartJS.register(
  RadialLinearScale,
  PointElement,
  LineElement,
  Filler,
  Legend,
  PointElement
);

const AIDemoV4 = () => {
  const dispatch = useDispatch();
  const {
    sendMessage,
    messages,
    setMessages,
    setSystemPrompt,
    initResponse,
    attemptDetails,
    generatingMessage,
    generationConfig,
    model: chatModel
  } = useChat();
  const { generateQuestionsV2, model, chatSessionRef } = useGeneratorV2();
  const sampleArray = [
    {
      interest: "Leadership",
      problem: "What is the most important quality of a leader?",
      options: [
        "Being the loudest person in the room",
        "Being able to listen to others and make fair decisions",
        "Knowing all the answers",
        "Always being in charge",
      ],
      correct_answer: "2",
    },
    {
      interest: "Organisational",
      problem: "Why is it important to organize your school bag?",
      options: [
        "To make it heavier",
        "To make it look nice",
        "To find things quickly and easily",
        "So other people can see your things",
      ],
      correct_answer: "3",
    },
    {
      interest: "Active listening",
      problem:
        "While someone is talking, what's a good way to show you're listening?",
      options: [
        "Looking at your phone",
        "Nodding and making eye contact",
        "Interrupting to share your own story",
        "Ignoring them",
      ],
      correct_answer: "2",
    },
    {
      interest: "Analytical thinking",
      problem:
        "You have a puzzle with many pieces. What is a good first step to solving it?",
      options: [
        "Start putting random pieces together",
        "Look at the picture on the box to understand the final image",
        "Give up if it looks too hard",
        "Ask someone else to solve it for you",
      ],
      correct_answer: "2",
    },
    {
      interest: "Artificial Intelligence",
      problem: "What is Artificial Intelligence (AI)?",
      options: [
        "A type of robot that looks like a human",
        "A type of car that drives itself",
        "A computer program that can do things that normally require human intelligence",
        "A video game character",
      ],
      correct_answer: "3",
    },
  ];

  const [openToast, setOpenToast] = useState(false);
  const [toastMsg, setToastMsg] = useState("");
  const [severityClass, setSeverityClass] = useState("success");

  const [newMessage, setNewMessage] = useState("");
  const [containerScrollDown, setContainerScrollDown] = useState("");
  const [forceUpdate, setForceUpdate] = useState(false);
  const historyRef = useRef(null);
  const scrollElemRef = useRef(null);
  const profile = useSelector((state) => state.profileReducer);
  const [openReportModal, setOpenReportModal] = useState(false);
  const [selectedTag, setSelectedTag] = useState([]);
  const [reportText, setReportText] = useState("");
  const [reportFor, setReportFor] = useState("");
  const [reportIndex, setReportIndex] = useState(-1);


  //XP system
  const [xp, setXp] = useState(0);
  const [level, setLevel] = useState(0);
  const [xpToNextLevel, setXpToNextLevel] = useState(100);
  const [xpBarWidth, setXpBarWidth] = useState(0);
  const [xpBarColor, setXpBarColor] = useState("green");
  const [penalty, setPenalty] = useState(0);
  const [remainingXP, setRemainingXP] = useState(10);
  const [attempt, setAttempt] = useState(0);
  const [selectedInterest, setSelectedInterest] = useState(1);

  const syllabus = [
    {
      subject: "Mathematics",
      units: [
        {
          unit: 1,
          name: "Knowing Our Numbers",
          topics: [
            "Large numbers up to 10 million",
            "Estimation of numbers",
            "Roman numerals",
            "Use of brackets",
          ],
        },
        {
          unit: 2,
          name: "Whole Numbers",
          topics: [
            "Introduction to whole numbers",
            "Properties of whole numbers",
            "Patterns in whole numbers",
            "Number line representation",
          ],
        },
        {
          unit: 3,
          name: "Playing with Numbers",
          topics: [
            "Factors and multiples",
            "Prime and composite numbers",
            "Divisibility rules",
            "HCF and LCM",
          ],
        },
        {
          unit: 4,
          name: "Basic Geometrical Ideas",
          topics: [
            "Points, lines, and line segments",
            "Angles and their types",
            "Triangles and quadrilaterals",
            "Circles and its components",
          ],
        },
        {
          unit: 5,
          name: "Understanding Elementary Shapes",
          topics: [
            "Measuring line segments",
            "Angles and their measurement",
            "Types of triangles and quadrilaterals",
            "3D shapes",
          ],
        },
        {
          unit: 6,
          name: "Integers",
          topics: [
            "Introduction to integers",
            "Operations on integers",
            "Representation of integers on a number line",
          ],
        },
        {
          unit: 7,
          name: "Fractions",
          topics: [
            "Types of fractions",
            "Equivalent fractions",
            "Operations on fractions",
            "Simplification of fractions",
          ],
        },
        {
          unit: 8,
          name: "Decimals",
          topics: [
            "Place value in decimals",
            "Addition, subtraction, multiplication, and division of decimals",
          ],
        },
        {
          unit: 9,
          name: "Data Handling",
          topics: [
            "Recording and organizing data",
            "Pictographs and bar graphs",
            "Probability basics",
          ],
        },
        {
          unit: 10,
          name: "Mensuration",
          topics: [
            "Perimeter of simple shapes",
            "Area of square and rectangle",
            "Applications of area and perimeter",
          ],
        },
        {
          unit: 11,
          name: "Algebra",
          topics: [
            "Introduction to algebraic expressions",
            "Simple equations and their solutions",
          ],
        },
        {
          unit: 12,
          name: "Ratio and Proportion",
          topics: ["Concept of ratio", "Proportion and unitary method"],
        },
        {
          unit: 13,
          name: "Symmetry",
          topics: ["Line of symmetry", "Reflection symmetry"],
        },
        {
          unit: 14,
          name: "Practical Geometry",
          topics: [
            "Construction of basic geometrical figures",
            "Using a compass and protractor",
          ],
        },
      ],
    },
    {
      subject: "Science",
      units: [
        {
          unit: 1,
          name: "Food: Where Does It Come From?",
          topics: ["Sources of food", "Components of food", "Food habits"],
        },
        {
          unit: 2,
          name: "Fibre to Fabric",
          topics: ["Natural and synthetic fibres", "Process of making fabric"],
        },
        {
          unit: 3,
          name: "Separation of Substances",
          topics: [
            "Methods of separation",
            "Solubility and saturation",
            "Water purification techniques",
          ],
        },
        {
          unit: 4,
          name: "Motion and Measurement of Distances",
          topics: ["Types of motion", "Measuring length", "Standard units"],
        },
        {
          unit: 5,
          name: "Electricity and Circuits",
          topics: ["Electric cells", "Conductors and insulators"],
        },
      ],
    },
    {
      subject: "English",
      units: [
        {
          unit: 1,
          name: "Grammar",
          topics: [
            "Nouns, Pronouns, Verbs",
            "Tenses (Present, Past, Future)",
            "Prepositions and Conjunctions",
          ],
        },
        {
          unit: 2,
          name: "Writing Skills",
          topics: ["Paragraph writing", "Letter writing", "Story writing"],
        },
      ],
    },
    {
      subject: "History",
      units: [
        {
          unit: 1,
          name: "In the Earliest Cities",
          topics: ["Harappan Civilization", "Trade and occupations"],
        },
        {
          unit: 2,
          name: "New Empires and Kingdoms",
          topics: ["Mauryan and Gupta empires", "Administration"],
        },
      ],
    },
    {
      subject: "Geography",
      units: [
        {
          unit: 1,
          name: "The Earth in the Solar System",
          topics: ["Planets and celestial bodies"],
        },
        {
          unit: 2,
          name: "Globe: Latitudes and Longitudes",
          topics: ["Earth’s imaginary lines"],
        },
      ],
    },
    {
      subject: "Civics",
      units: [
        {
          unit: 1,
          name: "Understanding Diversity",
          topics: ["Diversity in India", "Unity in Diversity"],
        },
        {
          unit: 2,
          name: "Rural Administration",
          topics: ["Panchayati Raj", "Local governance"],
        },
      ],
    },

    {
      subject: "Computer Science",
      units: [
        {
          unit: 1,
          name: "Introduction to Computers",
          topics: ["Computer basics", "Hardware and software"],
        },
        {
          unit: 2,
          name: "Coding Basics",
          topics: ["Introduction to Scratch/Python"],
        },
      ],
    },
    {
      subject: "General Knowledge",
      units: [
        {
          unit: 1,
          name: "Current Affairs",
          topics: ["Latest national and international news"],
        },
        {
          unit: 2,
          name: "Sports and Games",
          topics: ["Famous sports personalities"],
        },
      ],
    },
    {
      subject: "Art and Craft",
      units: [
        {
          unit: 1,
          name: "Drawing and Painting",
          topics: ["Basic sketching", "Watercolor techniques"],
        },
      ],
    },
    {
      subject: "Physical Education",
      units: [
        {
          unit: 1,
          name: "Yoga and Fitness",
          topics: ["Basic yoga poses", "Importance of fitness"],
        },
      ],
    },
  ];

  //radar chart
  // const dataArr = [4, 7, 3, 5, 4, 3];
  // const dataBeforeArr = [4, 7, 3, 5, 4, 3];
  const [listOfXPs, setListOfXPs] = useState([]);
  const [listOfLevels, setListOfLevels] = useState([]);
  // const options = {
  //   scale: {
  //     r: {
  //       max: 10,
  //       min: 0,
  //     },
  //   },
  // };
  const chartRef = useRef(null);
  const [data, setData] = useState({ labels: [], datasets: [] });

  // AI
  const listOfPenalties = {
    off_topic: {
      penalty_amount: 0,
      penalty_reason: "Off Topic",
    },
    hint_used: {
      penalty_amount: 2,
      penalty_reason: "Hint Used",
    },
    answer_requested: {
      penalty_amount: 5,
      penalty_reason: "Answer Requested",
    },
    incorrect_answer: {
      penalty_amount: 1,
      penalty_reason: "Incorrect Answer",
    },
  };
  const [aiMode, setAIMode] = useState(true);
  const [tmpMessages, setTmpMessages] = useState([]);
  const teacherAI = `You are an engaging and interactive teacher, guiding students through various subjects with a structured and thought-provoking approach. Your teaching style follows a process designed to encourage curiosity, critical thinking, and problem-solving skills. Begin each session by presenting a real-life problem or scenario related to the subject matter. Encourage students to think independently and attempt an answer before revealing any explanations. If a student asks for the answer, do not provide it immediately. Instead, provide step-by-step process to reach the end, ensuring they understand the fundamental concepts behind the solution. Your goal is to foster deep comprehension rather than rote memorization. When a student provides a correct answer, acknowledge their effort with positive reinforcement and smoothly transition to the next problem or topic. If a student provides an incorrect answer, identify their mistake and help them recognize where they went wrong. 
Instead of simply correcting them, offer hints or alternative perspectives that encourage them to arrive at the right conclusion independently. Ensure that all problems and discussions are rooted in real-world applications, making learning more relatable and engaging. Whether teaching mathematics, science, history, or any other subject, use scenarios that students encounter in their daily lives. Keep the learning process dynamic, supportive, and interactive, nurturing curiosity and confidence in every student.Below are the details for the evaluation of response and also the topics and questions should be aligned with current CBSE curriculum(INDIA) but should be asked as real-world problems.,
AI-generated response detection,Analyze the user's response and determine the probability (0.0 - 1.0) that it was AI-generated. 
Evaluate AI-generated response detection based on (Strict evaluation):  Writing style consistency, Unusual fluency and coherence, Sudden shift in tone or vocabulary complexity, Repetitive structure or overuse of formal phrases, Comparison with previous responses (if available).
JSON structure provided below: 
 JSON Structure = { "reason_if_not_ai_generated": String // provide a 5 words reason ,"is_response_ai_generated": Number // Probability from 0.0 (human) to 1.0 (AI-generated) ,"off_topic": boolean, //A response is considered off-topic if it does not address the core intent of the question, introduces unrelated subjects, or ignores the given context. “is_correct”: boolean, // if user gives correct answer of the question then it should be true else false   “is_penalty”: boolean, // Whether a penalty was applied   “penalty_amount”: number, // XP deducted if penalty is applied   "penalty_reason": string, // Slug of the penalty from the list   "response": string // Natural response to the user's answer }
 penaltiesList = [ { "slug": "off_topic", "name": "Off Topic", "penalty_amount": 0 } // apply this penalty is the response is not in the context of the question, { "slug": "hint_used", "name": "Hint Used", "penalty_amount": 2 }// apply this penalty if user ask for hint or guide in any way, { "slug": "answer_requested", "name": "Answer Requested", "penalty_amount": 5 } // apply this penalty if user asks for answer directly in any way, { "slug": "incorrect_answer", "name": "Incorrect Answer", "penalty_amount": 1 }// apply this penalty if user gives incorrect answer]. 
 I want your response to follow the above json structure and nothing else. Use this JSON structure after the first interaction only. 
 Also you should striclty reply in JSON at all costs.`;
 const reportTagsList = [
    {
      id: 1,
      name: "Incorrect Answer",
      slug: "incorrect_answer",
    },
    {
      id: 2,
      name: "Incorrect Question",
      slug: "incorrect_question",
    },
    {
      id: 3,
      name: "Incorrect Options",
      slug: "incorrect_options",
    },
    {
      id: 4,
      name: "Repetitive Question",
      slug: "repetitive_question",
    }
 ]

  // const [viewRadar, setViewRadar] = useState(false);
  const [speed, setSpeed] = useState(1);
  const [sidePanelLoader, setSidePanelLoader] = useState(false);
  const [questionLoader, setQuestionLoader] = useState(false);

  const toggleSwitch = () => {
    setSpeed(-1);
    const currentMessages = messages;
    const currentTmpMessages = tmpMessages;

    setMessages(currentTmpMessages);
    setTmpMessages(currentMessages);

    // let _shifter = tmpMessages;
    // setTmpMessages(messages);
    // setMessages(_shifter);
    setSystemPrompt(
      !aiMode
        ? teacherAI
        : "Act as a helpful teacher and in your response include all kind off markdowns"
    );
    setAIMode(!aiMode);
    // _shifter = []

    console.log(`Switch is ${!aiMode ? "ON" : "OFF"}`, tmpMessages, messages);
    setForceUpdate((prev) => !prev);
  };

  const handleCloseToast = () => {
    setOpenToast(false);
  };

  const handleCloseReportModal = () => {
    setOpenReportModal(false);
  }

  const handlePath = async (name) => {
    setQuestionLoader(true);
    console.log("topic Selected: ", name);
    // let excludedQuestions = JSON.parse(
    //   localStorage.getItem("excludedQ") || "[]"
    // );

    let excludedQuestionsObj =
      JSON.parse(localStorage.getItem("excludedQV1")) || {};
    let excludedQuestions = excludedQuestionsObj[name.toLowerCase()] || [];
    console.log("Excluded Questions: ", excludedQuestions);

    setSelectedInterest(name.toLowerCase());

    let generatedQuestion = await generateQuestionsV2({
      interests: [name.toLowerCase()],
      grade: 10,
      board: "CBSE",
      region: "India",
      language: "English",
      numberOfQuestions: 1,
      presence_penalty: 0,
    });

    // let questionObj = generatedQuestion[0].questions[0];
    let questionObj = generatedQuestion;

    setQuestion(questionObj.question);
    setMcq(questionObj.options);
    setCorrectAnswer(questionObj.correct_answer);
    setShowNext(false);
    setSelectedOption("");

    let tmpMessages = [
      {
        role: "user",
        content: JSON.stringify(generatedQuestion),
        hidden: true,
      },
      {
        role: "model",
        content: JSON.stringify(generatedQuestion),
        hidden: true,
      },
    ];
    setMessages(tmpMessages);

    let newQuestionsArr = [...excludedQuestions, questionObj.question];
    excludedQuestionsObj[name.toLowerCase()] = newQuestionsArr;
    console.log(
      "Excluded Questions Obj(before storing): \n",
      excludedQuestionsObj
    );
    localStorage.setItem("excludedQV1", JSON.stringify(excludedQuestionsObj));

    // let _interest = generatedQuestion[0].interest;
    let _interest = selectedSubject;

    console.log("Subject: ", selectedSubject);
    const previousXP = localStorage.getItem("xp_system") || null;
    if (!previousXP) {
      let xpSystem = {
        [_interest.toLowerCase()]: {
          xp: 0,
          level: 0,
          xpToNextLevel: 100,
          attemptDetails: [],
          questionSolved: 0,
        },
      };
      localStorage.setItem("xp_system", JSON.stringify(xpSystem));
    } else {
      let _previousXP = JSON.parse(previousXP);
      if (!_previousXP[_interest.toLowerCase()]) {
        _previousXP[_interest.toLowerCase()] = {
          xp: 0,
          level: 0,
          xpToNextLevel: 100,
          attemptDetails: [],
          questionSolved: 0,
        };
        localStorage.setItem("xp_system", JSON.stringify(_previousXP));
      } else {
        let xpDetailsOfInterest = _previousXP[_interest.toLowerCase()];
        setXp(xpDetailsOfInterest.xp);
        setLevel(xpDetailsOfInterest.level);
        setXpToNextLevel(xpDetailsOfInterest.xpToNextLevel);
      }
    }
    setQuestionLoader(false);
    setShowNext(false);
    setForceUpdate((prev) => !prev);
  };

  const generateChart = () => {
    let previousXP = localStorage.getItem("xp_system");
    if (!previousXP) return;
    let _previousXP = JSON.parse(previousXP);

    // let allLabels = profile.userSubInterests.map(
    //   (subInterest) => subInterest.subinterest.name
    // );

    let allLabels = syllabus.map((subject) => subject.subject);
    let labels = [];
    let _data = allLabels
      .map((label) => {
        if (
          _previousXP[label.toLowerCase()] &&
          _previousXP[label.toLowerCase()]?.xp > 0
        ) {
          labels.push(label);
          return _previousXP[label.toLowerCase()].xp;
        }
      })
      .filter((data) => data !== undefined);

    setData({
      labels: labels,
      datasets: [
        {
          label: "XP",
          data: _data,
          backgroundColor: "rgba(140, 199, 59, 0.2)",
          borderColor: "rgba(140, 199, 59, 1)",
          borderWidth: 1,
          pointBackgroundColor: "rgba(140, 199, 59, 1)",
          fill: false,
        },
      ],
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (newMessage.trim() !== "") {
      sendMessage(newMessage, false, aiMode);
      setNewMessage("");
    }
  };

  // const updateXPBar = () => {
  //   setXpBarWidth((xp / xpToNextLevel) * 100);
  //   if (xp < 100) {
  //     setXpBarColor("red");
  //   } else {
  //     setXpBarColor("green");
  //   }
  // };

  useEffect(() => {
    console.log("Updated Messages : ", messages);
  }, [messages]);

  useEffect(() => {
    if (profile.userSubInterests) {
      // let subInterests = profile.userSubInterests.map(
      //   (subInterest) => subInterest.subinterest.name
      // );
      // let excludedQ = localStorage.getItem("excludedQ") || "";

      // let initialPrompt = `I am interested in ${subInterests
      //   .slice(0, 10)
      //   .join(
      //     ", "
      //   )}. I am currently studying in 6th grade. Please generate (now) multiple-choice questions (MCQs) for each of these interests in an array using the schema below. one question for each interest.
      //   Each question should have four answer choices. Additionally, provide the correct answer for each question. you should only respond in JSON format.
      //  Question = {"interest": "Interest Name", "problem": "Problem Statement", "options": [ choice 1, choice 2, choice 3, choice 4 ], "correct_answer": "Correct Option Number"}
      //  examples : ${JSON.stringify(sampleArray)}
      //  Your response should only contain the JSON array of MCQs and nothing else—no introductions, explanations, or extra text.
      //  exclude the below questions:
      //  ${excludedQ}`;

      // console.log("initialPrompt: ", initialPrompt);
      // // sendMessage(initialPrompt, true, aiMode);
      generateChart();
      setSidePanelLoader(false);
    }
  }, [profile.userSubInterests]);

  useEffect(() => {
    if (!attemptDetails) return;
    let currentAttempt = {
      attempt: attempt,
      penalty: penalty,
      remaningXP: remainingXP,
    };
    const _attemptDetails = attemptDetails;

    if (_attemptDetails?.off_topic) {
      setToastMsg("You are off topic. Please stay on topic.");
      setSeverityClass("warning");
      setOpenToast(true);
    }

    if (_attemptDetails?.is_penalty) {
      let _penalty = listOfPenalties[_attemptDetails?.penalty_reason];
      if (_penalty) {
        currentAttempt.penalty =
          currentAttempt.penalty + _penalty.penalty_amount;
        currentAttempt.remaningXP =
          currentAttempt.remaningXP - _penalty.penalty_amount;
        currentAttempt.attempt = currentAttempt.attempt + 1;
        setToastMsg(
          `You have been penalized with ${_penalty.penalty_amount} XP for ${_penalty.penalty_reason}`
        );
        setSeverityClass("error");
        setOpenToast(true);
      }
      let isFailed = currentAttempt.remaningXP <= 0;
      if (isFailed) {
        setToastMsg(
          `You have failed to answer the question. Please try again.`
        );
        setSeverityClass("error");
        setOpenToast(true);
        setRemainingXP(10);
        setPenalty(0);
        setAttempt(0);
        return;
      }
    }

    if (_attemptDetails?.is_correct) {
      setToastMsg(
        `You have answered correctly. You have earned ${remainingXP} XP`
      );
      setSeverityClass("success");
      setOpenToast(true);

      currentAttempt.attempt = currentAttempt.attempt + 1;
      let previousXP = localStorage.getItem("xp_system");
      let _previousXP = JSON.parse(previousXP);
      let xpDetailsOfInterest = _previousXP[selectedInterest];
      xpDetailsOfInterest.xp = xpDetailsOfInterest.xp + remainingXP;
      xpDetailsOfInterest.questionSolved =
        xpDetailsOfInterest.questionSolved + 1;
      if (xpDetailsOfInterest.xp >= xpDetailsOfInterest.xpToNextLevel) {
        xpDetailsOfInterest.level = xpDetailsOfInterest.level + 1;
        xpDetailsOfInterest.xpToNextLevel =
          xpDetailsOfInterest.xpToNextLevel * 2;
      }
      xpDetailsOfInterest.attemptDetails = [
        ...xpDetailsOfInterest.attemptDetails,
        currentAttempt,
      ];
      console.log("xpDetailsOfInterest: ", xpDetailsOfInterest);

      localStorage.setItem("xp_system", JSON.stringify(_previousXP));
      setRemainingXP(10);
      setXp((previousXP) => previousXP + 10);
      setPenalty(0);
      setAttempt(0);
      generateChart();
      return;
    }

    setRemainingXP(currentAttempt.remaningXP);
    setPenalty(currentAttempt.penalty);
    setAttempt(currentAttempt.attempt);
  }, [attemptDetails]);

  useEffect(() => {
    if (!historyRef.current) {
      console.warn("⚠️ historyRef is null or undefined!");
      return;
    }

    setTimeout(() => {
      // historyRef.current.scrollTop = historyRef.current.scrollHeight;
      historyRef.current.scrollTo({
        top: historyRef.current.scrollHeight,
        behavior: "smooth",
      });
    }, 50);
  }, [containerScrollDown]);

  useEffect(() => {
    if (generatingMessage && historyRef.current) {
      historyRef.current.scrollTo({
        top: historyRef.current.scrollHeight,
        behavior: "smooth",
      });
    }
  }, [generatingMessage]);

  useEffect(() => {
    if (initResponse?.length > 0) {
      setSidePanelLoader(false);
    }
  }, [initResponse]);

  useEffect(() => {
    dispatch(getUserSubInterestsAction(localStorage.getItem("userDetailsID")));
    setSidePanelLoader(true);
  }, []);

  const [sidePanel, setSidePanel] = useState(true);
  const [chartPanel, setChartPanel] = useState(false);
  const [question, setQuestion] = useState("");
  const [mcq, setMcq] = useState([]);
  const [selectedOption, setSelectedOption] = useState("");
  const [correctAnswer, setCorrectAnswer] = useState("");
  const [showNext, setShowNext] = useState(false);
  const chartWrapperRef = useRef(null);
  const [chartDimensions, setChartDimensions] = useState({
    width: 30,
    height: 30,
  });
  const [topics, setTopics] = useState([]);
  const [selectedSubject, setSelectedSubject] = useState(null);
  const [showSubjects, setShowSubjects] = useState(true);
  const [showTopics, setShowTopics] = useState(false);

  const startResizing = (e) => {
    e.preventDefault();
    document.addEventListener("mousemove", resizePanel);
    document.addEventListener("mouseup", stopResizing);
  };

  const resizePanel = (e) => {
    if (!chartWrapperRef.current) return;

    const newWidth = Math.max(
      25,
      Math.min(((window.innerWidth - e.clientX) / window.innerWidth) * 100, 43)
    );
    const newHeight = Math.max(
      20,
      ((window.innerHeight - e.clientY) / window.innerHeight) * 100
    );

    // console.log("newWidth: ", newWidth, "newHeight: ", newHeight);
    setChartDimensions({
      width: newWidth,
      height: newHeight,
    });
  };

  const stopResizing = () => {
    document.removeEventListener("mousemove", resizePanel);
    document.removeEventListener("mouseup", stopResizing);
  };

  const toggleChartPanel = () => {
    setChartPanel(!chartPanel);
  };

  const toggleSidePanel = () => {
    setSidePanel(!sidePanel);
  };

  const handleOptionSelection = (option) => {
    console.log(
      "selected option: ",
      option === correctAnswer,
      option,
      correctAnswer
    );
    setSelectedOption(option);
    if (option === correctAnswer) {
      setToastMsg("Correct Answer");
      setSeverityClass("success");
      setOpenToast(true);

      let currentAttempt = {
        attempt: attempt,
        penalty: penalty,
        remaningXP: remainingXP,
      };

      currentAttempt.attempt = currentAttempt.attempt + 1;
      let previousXP = localStorage.getItem("xp_system");
      let _previousXP = JSON.parse(previousXP);
      // let xpDetailsOfInterest = _previousXP[selectedInterest];
      let xpDetailsOfInterest = _previousXP[selectedSubject.toLowerCase()];
      xpDetailsOfInterest.xp = xpDetailsOfInterest.xp + remainingXP;
      xpDetailsOfInterest.questionSolved =
        xpDetailsOfInterest.questionSolved + 1;
      if (xpDetailsOfInterest.xp >= xpDetailsOfInterest.xpToNextLevel) {
        xpDetailsOfInterest.level = xpDetailsOfInterest.level + 1;
        xpDetailsOfInterest.xpToNextLevel =
          xpDetailsOfInterest.xpToNextLevel * 2;
      }
      xpDetailsOfInterest.attemptDetails = [
        ...xpDetailsOfInterest.attemptDetails,
        currentAttempt,
      ];
      console.log("xpDetailsOfInterest: ", xpDetailsOfInterest);

      localStorage.setItem("xp_system", JSON.stringify(_previousXP));
      setRemainingXP(10);
      setXp((previousXP) => previousXP + 10);
      setPenalty(0);
      setAttempt(0);
      setShowNext(true);
      generateChart();

      return;
    } else {
      setToastMsg("Incorrect Answer");
      setSeverityClass("error");
      setOpenToast(true);
      return;
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      console.log("Enter pressed");
      e.target.blur();
      handleSubmit(e);
    }
  };

  const updateTopics = (name) => {
    console.log("Subject Selected: ", name);
    setSelectedSubject(name.toLowerCase());

    let subject = syllabus.find((subject) => subject.subject === name);
    let _topics = subject.units
      .map((unit) => unit.topics.map((topic) => unit.name + " - " + topic))
      .flat();
    setTopics(_topics);
    setShowSubjects(false);
    setShowTopics(true);
  };

  const handleOpenReportModal = (reportFor, index=-1) => {
    try {
      setOpenReportModal(true);
      setReportFor(reportFor);
      setReportIndex(index);
    } catch (error) {
      console.error("Error in handleReport: ", error);
      setToastMsg("Error in reporting");
      setSeverityClass("error");
      setOpenToast(true);
    } finally{
      setShowLoader(false);
    }
  } 

  const handleReportTagsSelection = (tag) => {
    console.log("Selected Tag: ", tag);
    setSelectedTag((prev) => {
      if (prev.includes(tag)) {
        return prev.filter((t) => t !== tag);
      } else {
        return [...prev, tag];
      }
    });
  }

  const handleReport = async () => {
    try{
      setShowLoader(true);
      console.log("Selected Tags: ", selectedTag);
      let reportTags = selectedTag.map((tag) => {
        let _tag = reportTagsList.find((t) => t.id === tag);
        return {
          id: _tag.id,
          name: _tag.name,
          slug: _tag.slug,
        };
      });

      const currentSession = localStorage.getItem("userAuthSessionID") || null;
      let _model = {}
      let content = {}
      let prompt = {}
      let history = null;
      let generationConfiguration = null
      if(reportFor === "MCQ_QUESTION"){
        _model = {
          ...model || null
        }
        history = chatSessionRef?.current?._history || null;
        prompt = {
          interests: selectedInterest,
          grade: 10,
          board: "CBSE",
          region: "India",
          language: "English",
          numberOfQuestions: 1,
          presence_penalty: 0,
        }
        content = {
          type: "MCQ_QUESTION",
          data: {
            question: question,
            options: mcq,
            correct_answer: correctAnswer,
          },
        }
        generationConfiguration = _model?.generationConfig || null
      }else if(reportFor === "CHAT"){
        _model = {
          ...chatModel || null
        }
        history = messages
        prompt = {
          userPrompt: messages
          .filter((message) => !message?.hidden)[reportIndex-1]?.content || null,
          content: messages
          .filter((message) => !message?.hidden)[reportIndex]?.content || null
        }
        content = {
          type: "CHAT",
          data: {
            messages: messages,
          },
        }
        generationConfiguration = generationConfig || null
      }

      console.log("model : ", _model, "index: ", reportIndex);
      delete _model["apiKey"];
      delete _model["generationConfig"];
      
      let reportObj = {
        newData: {
          content: content,
          reportTags: reportTags,
          additionalInfo: reportText,
          currentSession: currentSession,
        },
        prompt: prompt,
        model: _model,
        provider: "Google",
        generationConfiguration: generationConfiguration,
        chatHistory: history || null
      }


      const reportResponse = await reportAI(reportObj);
      console.log("Report Response: ", reportResponse);
      if (!reportResponse.status === 200) throw new Error("Error in reporting");
      setToastMsg("Reported successfully");
      setSeverityClass("success");
      setOpenToast(true);
      setReportText("");
      setSelectedTag([]);
      setOpenReportModal(false);
      setReportFor(null);
      setReportIndex(-1);
      console.log("Report Object: ", reportObj);
    } catch (error) {
      console.error("Error in handleReport: ", error);
      setToastMsg("Error in reporting");
      setSeverityClass("error");
      setOpenToast(true);
    }
    finally{
      setShowLoader(false);
    }
  }

  const [showLoader, setShowLoader] = useState(false);

  return (
    <div className="ai-demo-wrapper">
      <Header />
      <Snackbar
        open={openToast}
        autoHideDuration={3500}
        onClose={handleCloseToast}
      >
        <Alert
          variant="filled"
          onClose={handleCloseToast}
          severity={severityClass}
          sx={{ width: "100%" }}
        >
          {toastMsg}
        </Alert>
      </Snackbar>

      {/* Report Modal */}
      <CustomModal
        open={openReportModal}
        handleClose={handleCloseReportModal}
      >
        <h3
          style={{
            color: "#04a5a6",
          }}
        >
          Report
        </h3>
        <div className="modal" style={{ margin: "20px 0" }}>
          <label>Select:</label>
          <div 
            className="tags_wrapper" 
            style={{
              display: "flex",
              flexWrap: "wrap",
              gap: "5px",
              margin: "10px 0",
            }}
          >
            {
              reportTagsList.map((tag) => (
                <div 
                  className="tag"
                  key={tag.id+tag.slug}
                  style={{
                    background: `${selectedTag.includes(tag.id) ? "#04a5a6" : "white"}`,
                    color: `${selectedTag.includes(tag.id) ? "white" : "#04a5a6"}`,
                    border: `1px solid ${selectedTag.includes(tag.id) ? "white" : "#04a5a6"}`,
                    padding: "0.2rem 0.4rem",
                    fontSize: "0.8rem",
                    fontWeight: "600",
                    borderRadius: "6px",
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    handleReportTagsSelection(tag.id);
                  }}
                >
                  {tag.name}
                </div>
              ))
            }
          </div>
          <label>Addtional details (optional):</label>
          <textarea
            // type="text"
            placeholder="Type here..."
            value={reportText}
            onChange={(e) => setReportText(e.target.value)}
            style={{
              width: "100%",
              padding: "0.5rem",
              borderRadius: "5px",
              border: "1px solid #04a5a6",
              marginTop: "10px",
            }}
          ></textarea>
        </div>

        {/* Action Buttons */}
        <div
          style={{
            width: "100%",
            marginTop: "20px",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            gap: "20px",
          }}
        >
          <button
            style={{
              backgroundColor: "#04a5a6",
              color: "white",
              padding: "5px 7px",
              border: "none",
              borderRadius: "7px",
              display: "flex",
              alignItems: "center",
              gap: "5px",
              cursor: "pointer",
              fontSize: "14px",
            }}
            onClick={handleCloseReportModal}
          >
            <span>Cancel</span>
            <CloseOutlined style={{ fontSize: "16px" }} />
          </button>
          <button
            style={{
              backgroundColor: "#E33232",
              color: "white",
              padding: "5px 7px",
              border: "none",
              borderRadius: "7px",
              display: "flex",
              alignItems: "center",
              gap: "5px",
              cursor: "pointer",
              fontSize: "14px",
            }}
            onClick={()=>{handleReport()}}
          >
            <span>Report</span>
            <ErrorOutline style={{ fontSize: "16px" }} />
          </button>
        </div>
      </CustomModal>

      {showLoader && <Loader2 />}
      <Box
        sx={{
          display: "flex",
          width: "100%",
          height: "90vh",
          overflow: "hidden",
          position: "relative",
        }}
      >
        <div
          className="side-panel"
          style={{
            background: "#04a5a647",
            width: `${sidePanel ? "22%" : "0"}`,
            transition: "all 0.3s",
            position: "relative",
            padding: `${sidePanel ? "0.5rem" : "0"}`,
            display: "flex",
            flexDirection: "column",
            justifyContent: "start",
            borderRight: "2px solid rgba(0, 0, 0, 0.1)",
          }}
        >
          <div
            className="collapse-btn"
            onClick={toggleSidePanel}
            style={{
              position: "absolute",
              top: "2%",
              right: "0",
              transform: `translateX(${sidePanel ? "0" : "100%"})`,
              cursor: "pointer",
              padding: "5px",
              background: "white",
              borderRadius: `${sidePanel ? "50% 0 0 50%" : "0% 50% 50% 0%"}`,
              boxShadow: "0 0 5px rgba(0, 0, 0, 0.2)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              transition: "all 0.3s",
            }}
          >
            <ArrowLeft
              style={{
                color: "#04a5a6",
                fontSize: "1.8rem",
                transform: `rotate(${sidePanel ? "0" : "180deg"})`,
                transition: "all 0.5s",
              }}
            />
          </div>

          <div
            style={{
              overflow: "hidden",
              height: "100%",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <div
              className="header"
              style={{
                height: "7%",
                minHeight: "50px",
                display: "flex",
                alignItems: "center",
                justifyContent: "start",
                padding: "0.2rem",
                fontSize: "1.2rem",
                maxWidth: "100%",
                paddingRight: "16%",
                borderBottom: "1px solid rgba(0, 0, 0, 0.1)",
                color: "#04a5a6",
                fontWeight: "600",
              }}
            >
              {selectedSubject ? (
                <>
                  <span
                    className="selected-subject"
                    style={{
                      background: "#04a5a6",
                      color: "white",
                      padding: "0.5rem",
                      borderRadius: "5px",
                      fontSize: "0.9rem",
                      fontWeight: "600",
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      setShowSubjects(true);
                      setShowTopics(false);
                      setSelectedSubject(null);
                    }}
                  >
                    {selectedSubject.toUpperCase()}
                    <EditOutlined
                      style={{
                        color: "white",
                        marginLeft: "0.5rem",
                        fontSize: "0.9rem",
                        fontWeight: "600",
                      }}
                    />
                  </span>
                </>
              ) : (
                "Select Subject"
              )}
            </div>
            {sidePanelLoader && (
              <Loading loadingPrimary="" loadingSecondary="loading..." />
            )}
            {showSubjects && syllabus.length > 0 && (
              <div
                className="path-selection"
                style={{
                  maxHeight: "60%",
                  borderRadius: "10px",
                  padding: "10px",
                  boxShadow: "inset 0px 0px 10px 2px #d2d2d2",
                }}
              >
                {syllabus.map((subject, index) => {
                  let name = subject.subject;
                  return (
                    <div
                      className="path"
                      key={name + index}
                      style={{
                        padding: "0.2rem 0.4rem",
                        margin: "0.2rem",
                        minWidth: "3rem",
                        background: `${
                          selectedSubject + index === name.toLowerCase() + index
                            ? "#04a5a6"
                            : "transparent"
                        }`,
                        border: "1px solid #04a5a6",
                        transition: "all 0.3s",
                      }}
                      onClick={() => {
                        // handlePath(name);
                        updateTopics(name);
                      }}
                    >
                      <p
                        className="path-header"
                        style={{
                          fontSize: "0.8rem",
                          color: `${
                            selectedSubject + index ===
                            name.toLowerCase() + index
                              ? "white"
                              : "#04a5a6"
                          }`,
                          transition: "all 0.3s",
                        }}
                      >
                        {name}
                      </p>
                    </div>
                  );
                })}
              </div>
            )}

            {showTopics && topics.length > 0 && (
              <>
                <div
                  className="topic-header"
                  style={{
                    width: "100%",
                    padding: "0.2rem",
                    fontSize: "1rem",
                    fontWeight: "600",
                    marginTop: "1rem",
                    color: "#04a5a6",
                  }}
                >
                  Select Topic
                </div>
                <div
                  className="path-selection"
                  style={{
                    maxHeight: "100%",
                    borderRadius: "10px",
                    padding: "10px",
                    boxShadow: "inset 0px 0px 10px 2px #d2d2d2",
                  }}
                >
                  {topics.map((unit, index) => {
                    let key = unit;
                    return (
                      <div
                        className="path"
                        key={key}
                        style={{
                          padding: "0.2rem 0.4rem",
                          margin: "0.2rem",
                          minWidth: "3rem",
                          background: `${
                            selectedInterest === key.toLowerCase()
                              ? "#04a5a6"
                              : "transparent"
                          }`,
                          border: "1px solid #04a5a6",
                          transition: "all 0.3s",
                        }}
                        onClick={() => {
                          handlePath(key);
                        }}
                      >
                        <p
                          className="path-header"
                          style={{
                            fontSize: "0.8rem",
                            color: `${
                              selectedInterest === key.toLowerCase()
                                ? "white"
                                : "#04a5a6"
                            }`,
                            transition: "all 0.3s",
                          }}
                        >
                          {key}
                        </p>
                      </div>
                    );
                  })}
                </div>
              </>
            )}

            <div
              className="title"
              style={{
                width: "100%",
                display: "flex",
                alignItems: "end",
                justifyContent: "start",
                padding: "0.2rem",
                paddingBottom: "0.7rem",
                flex: 1,
              }}
            >
              <h5
                style={{
                  color: aiMode ? "#04a5a6" : "grey",
                  fontSize: "1rem",
                  fontWeight: "600",
                }}
              >
                {aiMode ? "Teacher " : "General "}AI
              </h5>
              <div
                className="ai-switcher"
                style={{
                  margin: "0 0 0.25rem 10px",
                }}
              >
                <label className="switch">
                  <input
                    type="checkbox"
                    checked={aiMode}
                    onChange={toggleSwitch}
                  />
                  <span className="slider"></span>
                </label>
              </div>
            </div>
          </div>
        </div>

        <div
          className="main-panel"
          style={{
            flex: 1,
            background: "#f6f6f6",
            display: "flex",
          }}
        >
          <div
            className="question-option-panel"
            style={{
              width: `${aiMode ? "50%" : "0"}`,
              display: "flex",
              flexDirection: "column",
              borderRight: "2px solid rgba(0, 0, 0, 0.1)",
              transition: "all 0.3s",
              overflow: `${aiMode ? "auto" : "hidden"}`,
            }}
          >
            <div
              className="question"
              style={{
                height: "70%",
                borderBottom: "2px solid rgba(0,0,0,0.1)",
                padding: "0.5rem",
                overflowY: "scroll",
              }}
            >
              <div
                className="header"
                style={{
                  height: "7%",
                  minHeight: "50px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "start",
                  padding: "0.2rem",
                  paddingLeft: `${sidePanel ? "0.2rem" : "2.2rem"}`,
                  fontSize: "1.2rem",
                  fontWeight: "600",
                  borderBottom: "1px solid rgba(0,0,0,0.1)",
                  transition: "all 0.3s",
                }}
              >
                Question
              </div>
              {questionLoader ? (
                <Loading loadingPrimary="" loadingSecondary="loading..." />
              ) : (
                <div
                  className="questionContent"
                  style={{
                    padding: "0.5rem",
                    fontSize: "1rem",
                  }}
                >
                  {question?.length > 0 ? (
                    <>
                      <div>{question}</div>
                      {showNext ? (
                        <div
                          className="nextBtn"
                          style={{
                            background: "#04a5a6",
                            color: "white",
                            padding: "0.2rem 0.5rem",
                            fontSize: "0.9rem",
                            fontWeight: "500",
                            borderRadius: "7px",
                            cursor: "pointer",
                            textAlign: "center",
                            transition: "0.2s ease-in-out",
                            maxWidth: "max-content",
                            margin: "0.5rem 0",
                            border: "1px solid #04a5a6",
                            boxShadow: "0 0 5px rgba(0, 0, 0, 0.1)",
                            animation: "pump 0.5s ease-in 2",
                          }}
                          onClick={() => handlePath(selectedInterest)}
                        >
                          Next Question
                        </div>
                      ) : (
                        ""
                      )}
                      <Divider style={{ marginTop: "1rem" }} />
                      <button
                        className="report"
                        style={{
                          marginTop: "0.5rem",
                          outline: "none",
                          border: "none",
                          background: "transparent",
                          cursor: "pointer",  
                        }}
                        onClick={()=>{handleOpenReportModal("MCQ_QUESTION")}}
                      >
                        <ErrorOutline
                          style={{ color: "#888888", fontSize: "1.2rem" }}
                        />
                      </button>
                    </>
                  ) : (
                    "Please Select an Interest from the side panel"
                  )}
                </div>
              )}
            </div>
            <div
              className="options-content"
              style={{
                marginBottom: "20px",
                fontSize: "1rem",
                display: "flex",
                flexWrap: "wrap",
                height: "35%",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              {mcq?.length > 0
                ? mcq.map((item, index) => (
                    <label
                      key={item} // Ensure unique keys
                      className="mcq-option"
                      style={{
                        width: "44%",
                        minHeight: "33%",
                        height: "33%",
                        margin: "0.2rem",
                        padding: "0.5rem",
                        border:
                          selectedOption === index
                            ? "2px solid #04a5a6" // Highlight selected option
                            : "1px solid rgba(0,0,0,0.1)",
                        borderRadius: "10px",
                        background:
                          selectedOption === index ? "#e3f2fd" : "white", // Change background when selected
                        cursor: "pointer",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontSize: "0.9rem",

                        textAlign: "center  ",
                        transition: "0.2s ease-in-out",
                      }}
                    >
                      <input
                        type="radio"
                        name="mcq"
                        value={item}
                        checked={selectedOption === item}
                        onChange={() => handleOptionSelection(index)}
                        style={{
                          position: "absolute",
                          opacity: 0,
                          pointerEvents: "none",
                        }}
                        disabled={showNext}
                      />
                      {item}
                    </label>
                  ))
                : ""}
            </div>
          </div>
          <div
            className="chat-wrapper-special"
            style={{
              width: "50%",
              margin: "0",
              height: "100%",
              overflow: "hidden",
              flex: "1",
            }}
          >
            <div
              className="input-and-config-container"
              style={{
                height: "85%",
                overflowY: "scroll",
                padding: "0 0.5rem",
              }}
              ref={historyRef}
            >
              {messages?.length ? (
                <div
                  className="chat-history"
                  key={forceUpdate}
                  style={{
                    marginBottom: "10px",
                    marginTop: "4rem",
                    padding: "0.5rem",
                  }}
                  ref={scrollElemRef}
                >
                  {messages
                    .filter((message) => !message?.hidden)
                    .map((message, index) => {
                      // index === messages.length - 2 && resetSpeed();
                      return (
                        <>
                          <div
                            key={index}
                            className={`message message-${message.role}${
                              message.role === "model" ? "-v2" : ""
                            }`}
                          >
                            <div className="message-header"></div>
                            <span className="content">
                              {message.recommendations ? (
                                <Message
                                  key={index}
                                  text={message.content}
                                  recommendations={message.recommendations}
                                  role={message.role}
                                  speed={speed}
                                  setContainerScrollDown={setContainerScrollDown}
                                  setShowLoader={setShowLoader}
                                />
                              ) : (
                                <Courses
                                  key={index}
                                  text={message.content}
                                  courseRecommendations={
                                    message.courseRecommendations
                                  }
                                  thirdPartyMatches={message.thirdPartyMatches}
                                  role={message.role}
                                  speed={speed}
                                  setContainerScrollDown={setContainerScrollDown}
                                  setShowLoader={setShowLoader}
                                />
                              )}
                            </span>
                          </div>
                          {message.role === "model" && (
                            <div className="actions" style={{ marginTop: "0.5rem" }}>
                              <span><ErrorOutline style={{
                                color: "#888888",
                                fontSize: "1.2rem",
                                cursor: "pointer",
                              }} onClick={()=>{ handleOpenReportModal('CHAT', index) }}/></span>
                            </div>
                          )}
                        </>
                      );
                    })}
                  {generatingMessage && (
                    <div
                      className="message message-model-v2 generating"
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "start",
                        padding: "0.5rem",
                        margin: "0.5rem 0",
                        maxHeight: "35px",
                        marginTop: "1.5rem",
                        transition: "all 0.3s",
                        opacity: `${generatingMessage ? "1" : "0"}`,
                      }}
                    >
                      <span className="generating">Generating response...</span>
                    </div>
                  )}
                </div>
              ) : (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "100%",
                    textAlign: "center",
                    fontSize: "1rem",
                    color: "#04a5a6",
                    width: "100%",
                  }}
                >
                  {aiMode
                    ? "Welcome to your AI Tutor! 🚀 I'm here to help you level up your skills by asking questions and guiding you toward the right answers. Select a skill from the list above, and let's get started! I'll challenge you with questions—if you get it right, we move forward. If not, don't worry! I'll guide you step by step to help you understand and master the concept. Ready to learn? Let's go! 🎯"
                    : "Hello! 🤖 I'm your AI assistant, here to help you with anything you need—whether it's answering questions, solving problems, or guiding you step by step. Just ask away, and let's explore together! 🚀"}
                  :
                </div>
              )}
            </div>
            <div
              className="input-container"
              style={{
                width: "100%",
                height: "13%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                padding: "0.25rem 0",
                boxShadow: "0 -10px 15px 10px #00000010",
              }}
            >
              <div
                className="input-wrapper-v2"
                style={{
                  width: "90%",
                  maxWidth: "50vw",
                  position: "relative",
                  height: "100%",
                  maxHeight: "80px",
                }}
              >
                <textarea
                  type="text"
                  placeholder="Enter your message"
                  value={newMessage}
                  onChange={(e) => setNewMessage(e.target.value)}
                  onKeyDown={handleKeyDown}
                  style={{
                    top: "0",
                    left: "0",
                    right: "0",
                    bottom: "0",
                    position: "absolute",
                    border: "1px solid rgba(0,0,0,0.1)",
                    borderRadius: "10px",
                    padding: "10px",
                    resize: "none",
                    boxSizing: "border-box",
                    paddingRight: "35px",
                    minWidth: "100% !important",
                  }}
                />
                <button
                  type="submit"
                  disabled={newMessage.trim() === ""}
                  onClick={handleSubmit}
                  style={{
                    position: "absolute",
                    right: "10px",
                    top: "50%",
                    width: "30px",
                    height: "30px",
                    background: "#04a5a6",
                    color: "white",
                    border: "none",
                    cursor: "pointer",
                    transform: "translateY(-50%)",
                    borderRadius: "50%",
                    padding: "2px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <ArrowUpwardOutlined
                    style={{ color: "white", fontSize: "1rem" }}
                  />
                </button>
              </div>
            </div>
          </div>
        </div>

        <div
          ref={chartWrapperRef}
          className="chart-panel"
          style={{
            background: "#f0f0f0",
            height: `${chartDimensions.width}vw`,
            width: `${chartPanel ? `${chartDimensions.width}vw` : "0%"}`,
            position: "absolute",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            transition: "all 0.3s",
            right: "0",
            top: "0",
            zIndex: "2",
            borderBottomLeftRadius: "10px",
            boxShadow: "-5px 5px 15px rgba(0, 0, 0, 0.1)",
            border: "2px solid rgba(0, 0, 0, 0.1)",
            borderTop: "none",
            borderRight: "none",
            padding: `${chartPanel ? "0.2rem" : "0"}`,
            // overflow: "hidden",
          }}
        >
          <div
            className="collapse-btn"
            onClick={toggleChartPanel}
            style={{
              position: "absolute",
              top: "3%",
              left: "0",
              transform: `translateX(${chartPanel ? "0%" : "-100%"})`,
              cursor: "pointer",
              padding: "5px",
              background: "white",
              borderRadius: `${chartPanel ? "0 50% 50% 0" : "50% 0 0 50%"}`,
              boxShadow: "0 0 5px rgba(0, 0, 0, 0.2)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              transition: "all 0.3s",
              zIndex: "2",
              animation: `${showNext ? "blink 1s ease-in-out 3" : ""}`,
            }}
          >
            <ArrowLeft
              style={{
                color: "#04a5a6",
                fontSize: "1.8rem",
                transform: `rotate(${chartPanel ? "180deg" : "0"})`,
                transition: "all 0.5s",
              }}
            />
          </div>
          <Radar
            data={data}
            style={{ width: "100%", height: "100%", position: "relative" }}
            ref={chartRef}
            options={{
              events: ["click"],
              showTooltip: false,
              animation: {
                duration: 0,
                onComplete: function (context) {
                  var ctx = context.chart.ctx;
                  ctx.font = `bold 12px Arial`;
                  ctx.textAlign = "center";
                  ctx.textBaseline = "bottom";

                  const datasets = context.chart.getDatasetMeta(0);

                  context.chart._metasets.forEach(function (dataset) {
                    for (var i = 0; i < dataset.data.length; i++) {
                      var model = dataset.data[i];
                      ctx.fillText(
                        dataset.data[i]?.$context.raw,
                        model.x,
                        model.y - 5
                      );
                    }
                  });
                },
              },
              responsive: true,
              scales: {
                r: {
                  beginAtZero: true,
                  angleLines: {
                    display: true,
                  },
                  suggestedMin: 0,
                  suggestedMax: Math.max(...listOfXPs, ...listOfLevels) + 10, // Adjusts based on data range
                  ticks: {
                    callback: (value) => {
                      const levelIndex = [100, 200, 400, 800, 1600].indexOf(
                        value
                      );
                      return levelIndex !== -1
                        ? `Level ${levelIndex + 1}`
                        : `${value} XP`; // Show "Level X" only at thresholds
                    },
                    backdropColor: "transparent",
                  },
                },
              },
              plugins: {
                legend: {
                  position: "top",
                },
              },
            }}
          />
          <div
            className="resize-handle"
            onMouseDown={startResizing}
            style={{
              position: "absolute",
              bottom: "0",
              left: "0",
              width: "15px",
              height: "15px",
              background: "transparent",
              cursor: "nesw-resize",
              transform: "rotate(-45deg)",
              // boxShadow: "0 0 5px rgba(0, 0, 0, 0.2)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <ArrowLeft
              style={{
                color: "#04a5a6",
                // boxShadow: "0 0 5px rgba(0, 0, 0, 0.2)",
              }}
            />
          </div>
        </div>
      </Box>
    </div>
  );
};

export default AIDemoV4;
